import { Component, OnInit } from '@angular/core'
import { Location } from '@angular/common'
import { AppService } from '@@services/app.service'

@Component({
    standalone: false,
    selector: 'app-service-unavailable',
    templateUrl: './service-unavailable.component.html',
    styleUrls: ['./service-unavailable.component.css']
})
export class ServiceUnavailableComponent implements OnInit {
    isServerAvailable?: boolean

    constructor(
        private location: Location,
        private appService: AppService
    ) {}

    ngOnInit() {
        this.getServerStatus()
    }

    getServerStatus(goBackIfServerAvailable?: boolean) {
        this.appService.checkServerAvailable().subscribe((res: any) => {
            this.isServerAvailable = res.message == 'valid'

            if (goBackIfServerAvailable && this.isServerAvailable) {
                this.location.back()
            }
        })
    }
}
